export enum ExpeditionsActionTypes {
  GET_LIST_EXPEDITIONS_SUCCESS = "EXPEDITIONS_GET_LIST_SUCCESS",
  GET_LIST_EXPEDITIONS_ERROR = "EXPEDITIONS_GET_LIST_ERROR",
  GET_LIST_EXPEDITIONS = "EXPEDITIONS_GET_LIST",
  CREATE_EXPEDITION = "CREATE_EXPEDITION",
  CREATE_EXPEDITION_SUCCESS = "CREATE_EXPEDITION_SUCCESS",
  CREATE_EXPEDITION_ERROR = "CREATE_EXPEDITION_ERROR",
  GET_EXPEDITION = "GET_EXPEDITION",
  GET_EXPEDITION_SUCCESS = "GET_EXPEDITION_SUCCESS",
  GET_EXPEDITION_ERROR = "GET_EXPEDITION_ERROR",
  UPDATE_EXPEDITION = "UPDATE_EXPEDITION",
  UPDATE_EXPEDITION_SUCCESS = "UPDATE_EXPEDITION_SUCCESS",
  UPDATE_EXPEDITION_ERROR = "UPDATE_EXPEDITION_ERROR",
  UPDATE_STATUS_EXPEDITION = "UPDATE_STATUS_EXPEDITION",
  UPDATE_STATUS_EXPEDITION_SUCCESS = "UPDATE_STATUS_EXPEDITION_SUCCESS",
  UPDATE_STATUS_EXPEDITION_ERROR = "UPDATE_STATUS_EXPEDITION_ERROR",
  DELETE_EXPEDITION = "DELETE_EXPEDITION",
  DELETE_EXPEDITION_SUCCESS = "DELETE_EXPEDITION_SUCCESS",
  DELETE_EXPEDITION_ERROR = "DELETE_EXPEDITION_ERROR",
}
